module.exports = __webpack_public_path__ + "img/campaigns.0c8435d1.svg";